export enum OwnershipType {
    SYSTEM = 'SYSTEM',
    PRIVATE = 'PRIVATE'
}
